module.exports = __webpack_public_path__ + "static/media/10-Spades.dc257ad5.svg";